import React from 'react';
import GlobalStyles from 'theme/global';
import Routes from 'scenes/App/Routes/Routes';

const App = () => (
	<>
		<GlobalStyles />
		<Routes />
	</>
);

export default App;
